import React from 'react';
import { Component } from '../../../types';
import { AssignmentWidget } from '../../progress/AssignmentWidget';

export interface SharedAssignmentWidgetComponentProps {
  component: Component;
  isViewerMode?: boolean;
}

export const SharedAssignmentWidgetComponent: React.FC<SharedAssignmentWidgetComponentProps> = ({
  component,
  isViewerMode = false,
}) => {
  return (
    <AssignmentWidget
      component={component}
      isViewerMode={isViewerMode}
    />
  );
};

SharedAssignmentWidgetComponent.displayName = 'SharedAssignmentWidgetComponent';
